// Path: ./src/locales/i18n.ts
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./en/translation.json";
import zh from "./zh/translation.json";
import { convertLanguageJsonToObject } from "./translations";
import {
  isLocalStorageAvailable,
  isSessionStorageAvailable,
} from "../utils/localStorage";

export const translationsJson = {
  en: {
    translation: en,
  },
  zh: {
    translation: zh,
  },
};

// Create the 'translations' object to provide full intellisense support for the static json files.
convertLanguageJsonToObject(en);

const buildDetectionConfig = () => {
  const order: string[] = ["querystring"];
  const caches: string[] = [];

  if (isLocalStorageAvailable()) {
    order.push("localStorage");
    caches.push("localStorage");
  }

  order.push("cookie");

  if (isSessionStorageAvailable()) {
    order.push("sessionStorage");
    caches.push("sessionStorage");
  }

  order.push("navigator");
  caches.push("cookie");

  return {
    order,
    lookupQuerystring: "language",
    lookupLocalStorage: "Lang",
    lookupCookie: "Lang",
    lookupSessionStorage: "Lang",
    caches,
  };
};

export const i18n = i18next
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources: translationsJson,
    fallbackLng: "en",
    debug:
      // @ts-ignore
      window?.config?.NODE_ENV !== "production" &&
      // @ts-ignore
      window?.config?.NODE_ENV !== "test",

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: buildDetectionConfig(),
  });
